import React from 'react';
import { isEmpty } from '../../utils/obj-utils';

function HeaderLinkDisplay({ headerMessage, headerLink, headerLinkText }) {
    if (!headerLink || isEmpty(headerLinkText)) {
        return null;
    }

    return (
        <p>{headerMessage}&nbsp;
            <a
                className='link'
                onClick={headerLink}>
                {headerLinkText}
            </a>
        </p>
    );
}

export default HeaderLinkDisplay;